/* global */
/* eslint-disable */
import REACT_CONFIG from 'REACT_CONFIG';

function initConfig() {
  let isInspectorArm;
  let isDemoMode;
  let pdfPreviewIsActive;
  let facetCheckingTimeoutInSec;
  let isValidateCertificate;
  let oldVersionMessagesTimeout;
  let showInsuranceTaxes;
  let showSelfInsuranceTaxes;
  let hasExtendedPayment;
  let finesLoadedCheckingTimeoutInSec;
  let inactivityLimitMs;
  let inactivityAfterModal;
  let enableNotificationsCenter;
  try {
    isInspectorArm = REACT_CONFIG.REACT_APP_IS_INSPECTOR_ARM;
    isDemoMode = REACT_CONFIG.REACT_APP_IS_DEMO_MODE;
    pdfPreviewIsActive = REACT_CONFIG.REACT_APP_PDF_PREVIEW_IS_ACTIVE;
    facetCheckingTimeoutInSec = +REACT_CONFIG.REACT_APP_FACET_CHECKING_TIMEOUT_IN_SEC;
    isValidateCertificate = REACT_CONFIG.REACT_APP_IS_VALIDATE_CERTIFICATE;
    oldVersionMessagesTimeout = REACT_CONFIG.REACT_APP_OLD_VERSION_MESSAGES_TIMEOUT;
    showInsuranceTaxes = REACT_CONFIG.REACT_APP_SHOW_INSURANCE_TAXES;
    showSelfInsuranceTaxes = REACT_CONFIG.REACT_APP_SHOW_SELF_INSURANCE_TAXES;
    hasExtendedPayment = REACT_CONFIG.REACT_APP_HAS_EXTENDED_PAYMENT;
    finesLoadedCheckingTimeoutInSec = REACT_CONFIG.REACT_APP_FINES_LOADED_TIMEOUT_IN_SEC;
    inactivityLimitMs = REACT_CONFIG.REACT_APP_INACTIVITY_LIMIT_MS;
    inactivityAfterModal = REACT_CONFIG.REACT_APP_INACTIVITY_AFTER_MODAL;
    enableNotificationsCenter = REACT_CONFIG.REACT_APP_ENABLE_NOTIFICATIONS_CENTER;
  } catch (err) {
    console.error('config initialization failed');
  }
  const vipnetConfig = {
    host: '127.0.0.1',
    httpServicePort: '12401',
    sslServicePort: '12402',
    httpClientPort: '61111',
    sslClientPort: '61112',
    defaultPath: '/webhost',
    serialNumber: '8299-VUP3-WWG4-XG3R',
    extendedKeyUsages: ['1.3.6.1.5.5.7.3.2', '1.3.6.1.5.5.7.3.4'],
  };
  const hrefToNewLK = `${window.location.origin}/lkfl`;
  const hrefToNewAppeals = `${window.location.origin}/lkfl/individual/appeals`;
  const goToNewAppeals = () => {
    window.location.replace(hrefToNewAppeals);
  };
  const goToNewLK = (href = hrefToNewLK) => {
    window.location.replace(href);
  };

  const tokenNames = {
    demo: 'demo_token',
    arm: 'arm_inspector_token',
    lkfl: 'token',
  };
  const config = Object.freeze({
    basePath: process.env.PUBLIC_URL,
    apiBaseUrl: REACT_CONFIG.REACT_APP_API_URL,
    authBasePath: isInspectorArm ? '/auth-ofc' : '/auth',
    apiTimeout: REACT_CONFIG.REACT_APP_API_TIMEOUT,
    tapsApiBaseUrl: REACT_CONFIG.REACT_APP_TAPS_API_URL,
    tapsAttachApiUrl: REACT_CONFIG.REACT_APP_TAPS_ATTACH_API_URL,
    authApiBaseUrl: REACT_CONFIG.REACT_APP_AUTH_API_URL,
    fiasApiBaseUrl: REACT_CONFIG.REACT_APP_FIAS_API_URL,
    fiasApiNewBaseUrl: REACT_CONFIG.REACT_APP_FIAS_API_NEW_URL,
    datetimeFormat: 'DD.MM.YYYY',
    serverDatetimeFormat: 'YYYY-MM-DD',
    fullDateTimeFormat: 'DD.MM.YYYY HH:mm:SS',
    fullServerDateTimeFormat: 'YYYY-MM-DD HH:mm:SS',
    // TODO: move clientId and clientSecret to property!
    clientId: isInspectorArm ? 'staff-arm' : 'taxpayer-browser',
    clientSecret: isInspectorArm
      ? '8armHnYAtwJS7fmfvu2rnAHT6k34DccG'
      : '7VIPKnZAtwQL7fmtvu2rnAHT6c34DkkG',
    ESAuthClientId: 'taxpayer-cert-browser',
    ESAuthClientSecret: 'VX@*k!iipmEoTnNqR9UAjbnilsth24T&',
    isInspectorArm: isInspectorArm,
    isDemoMode: isDemoMode,
    isValidateCertificate,
    tokenItemName: getTokenItemName(),
    refreshTokenItemName: isInspectorArm ? 'arm_inspector_refresh_token' : 'refresh_token',
    inactivityLimitMs,
    inactivityAfterModal,
    vipnetConfig,
    showInsuranceTaxes,
    showSelfInsuranceTaxes,
    facetCheckingTimeoutInSec,
    pdfPreviewIsActive,
    oldVersionMessagesTimeout,
    hasExtendedPayment,
    enpStartDate: '2019-01-01T00:00:00+03:00',
    finesLoadedCheckingTimeoutInSec,
    chatBotUrl: REACT_CONFIG.REACT_APP_CHAT_BOT_URL,
    recaptchaApiKey: REACT_CONFIG.REACT_APP_RECAPTCHA_API_KEY || '',
    isCovid19: REACT_CONFIG.REACT_APP_IS_COVID_19,
    mapsApiKey: 'b6344ee6-de17-453a-b472-faaaf97b062f',
    enableNotificationsCenter,
    goToNewAppeals,
    goToNewLK,
    hrefToNewAppeals,
    hrefToNewLK,
  });

  window.yaCounterId = REACT_CONFIG.REACT_APP_YA_COUNTER_ID || '';
  window.additionalYaCounterId = REACT_CONFIG.REACT_APP_ADDITIONAL_YA_COUNTER_ID || '';

  function getTokenItemName() {
    if (isDemoMode) {
      return tokenNames.demo;
    }
    return isInspectorArm ? tokenNames.arm : tokenNames.lkfl;
  }
  return config;
}
export default initConfig();
